import get from 'get-value';
import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const aseExportDealers = (state = {
    isLoadingDealer: false,
    dealers: [],
    correlationId: null,
}, action) => {
    switch (action.type) {
        case aseWebsocketCommands.ASE_DEALERS_GET: {
            return Object.assign({}, state, {isLoadingDealer: true});
        }
        case aseWebsocketCommands.ASE_DEALERS_SEND: {
            const dealers = get(action, 'payload.dealers', {default: []});
            const correlationId = get(action, 'payload.correlationId');
            return Object.assign({}, state, {
                isLoadingDealer: false,
                dealers,
                searchResults: correlationId ? { correlationId, dealers } : state.searchResults,
            });
        }
        case aseWebsocketCommands.ASE_DEALERS_SEND_ERROR: {
            return Object.assign({}, state, {isLoadingDealer: false});
        }
        default:
            return state;
    }
};
